<template>
    <div>
        <el-carousel :interval="5000" indicator-position="none" height="2.63rem">
            <el-carousel-item v-for="(item, index) in data_list.jrwm_lbtp" :key="index" @click="openweb(item.image_url)">
                <img :src="item.format_img" style="width: 100%; height: 100%;" alt="">
            </el-carousel-item>
        </el-carousel>
        
        <div style="padding: 0 0.3rem; height: 10rem;">
            <div class="flx fdc tl" style="margin-top: 0.6rem;">
                <span style="font-size: 0.48rem; color: rgb(64, 64, 64);">商务合作 &nbsp; <span style="font-size: 0.36rem;"><span style="color: rgb(206, 206, 206);">Business cooperation</span></span></span>
                <div style="width: 0.8rem;height: 1px; background-color: #555; margin-top: 0.3rem;"></div>
            </div>

            <div class="flx aic" style="margin-top: 0.5rem;">
                <img src="../../assets/lianxiren6.png" style="width: 0.5rem;height: 0.5rem;" alt="">
                <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 0.36rem; margin-left: 0.36rem;">
                    <span>联系人</span>
                    <span style="margin-left: 0.3rem;">{{data_list.linkman}}</span>
                </div>
            </div>
            <div class="flx aic" style="margin-top: 0.5rem;">
                <img src="../../assets/youxiang2.png" style="width: 0.5rem;height: 0.5rem;" alt="">
                <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 0.36rem; margin-left: 0.36rem;">
                    <span>电子邮箱</span>
                    <span style="margin-left: 0.3rem;">{{data_list.email}}</span>
                </div>
            </div>

            <div class="flx aic" style="margin-top: 0.5rem;">
                <img src="../../assets/emidianhua2.png" style="width: 0.5rem;height: 0.5rem;" alt="">
                <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 0.36rem; margin-left: 0.36rem;">
                    <span>联系电话</span>
                    <span style="margin-left: 0.3rem;">{{data_list.phone}}</span>
                </div>
            </div>

            <div class="flx aic" style="margin-top: 0.5rem;">
                <img src="../../assets/daohangdizhi.png" style="width: 0.5rem;height: 0.5rem;" alt="">
                <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 0.36rem; margin-left: 0.36rem;">
                    <span>联系地址</span>
                    <span style="margin-left: 0.3rem;">{{data_list.address}}</span>
                </div>
            </div>
            <div class="flx aic" style="margin-top: 0.5rem;">
                <img src="../../assets/weixin.png" style="width: 0.5rem;height: 0.5rem;" alt="">
                <div class="flx aic" style="color: rgb(150, 150, 150); font-size: 0.36rem; margin-left: 0.36rem;">
                    <span>微信号</span>
                    <span style="margin-left: 0.3rem;">{{data_list.wechat_id}}</span>
                </div>
            </div>

            <div class="flx" style="margin-top: 0.5rem;">
                <img style="width: 2.6rem; height: 2.6rem;" :src="data_list.xcx_img" alt="">
                <img style="width: 2.6rem; height: 2.6rem; margin-left: 0.5rem;" :src="data_list.gzh_img" alt="">
            </div>
        </div>

        <div style="padding: 0 0.3rem; margin-bottom: 0.8rem;">
            <div class="tc" style="font-size: 0.4rem;">给我们留言</div>
            <div class="flx aic" style="margin-top: 0.4rem;">
                <div style="width: 1.6rem; font-size: 0.36rem;">姓名</div>
                <el-input style="width: 7.6rem;" v-model="name" placeholder="请输入内容"></el-input>
            </div>
            <div class="flx aic" style="margin-top: 0.4rem;">
                <div style="width: 1.6rem; font-size: 0.36rem;">电话</div>
                <el-input style="width: 7.6rem;" v-model="phone" placeholder="请输入内容"></el-input>
            </div>
            <div class="flx aic" style="margin-top: 0.4rem;">
                <div style="width: 1.6rem; font-size: 0.36rem;">邮箱</div>
                <el-input style="width: 7.6rem;" v-model="email" placeholder="请输入内容"></el-input>
            </div>
            <div class="flx aic" style="margin-top: 0.4rem;">
                <div style="width: 1.6rem; font-size: 0.36rem;">留言</div>
                <el-input
                    style="width: 7.6rem;"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入内容"
                    v-model="textarea">
                </el-input>
            </div>
            <div class="flx jcc">
                <el-button style="background-color: #C8161D; width: 5rem; color: #fff; margin: 0.5rem 0 0 0;" @click="tijiao()">立即提交</el-button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'IndexPage5',
    data () {
        return {
            data_list: '',
            name: '',
            phone: '',
            email: '',
            textarea: '',
        }
    },
    methods: {
        getData() {
            this.$post('index.php?s=/api/index/contact_us', {
                wxapp_id: 10001
            })
            .then((res) => {
                if(res.code == 1) {
                    this.data_list = res.data.list;
                }
            }) 
        },
        tijiao() {
            this.$post('index.php?s=/api/index/message', {
                wxapp_id: 10001,
                linkman: this.name,
                phone: this.phone,
                email: this.email,
                content: this.textarea
            })
            .then((res) => {
                if(res.code == 1) {
                    this.$message({
                        offset: 300,
                        message: res.msg,
                        type: 'success'
                    });
                } else {
                    this.$message({
                        offset: 300,
                        message: res.msg,
                        type: 'error'
                    });
                }
            }) 
        },
        openweb(e) {
            if(e) {
                var aa = e.split('?');
                aa[0] = aa[0] + 2;
                var bb = aa.join('?');
                window.open(bb)
            }
        },
    },
    created() {
        var data = this.$route.query;
        document.title = data.name;
        this.getData();
    },
    mounted() {

	},
    destroyed() {

    }

}
</script>

<style scoped>
    .dffaaa{
        color: #333;
    }
</style>



// WEBPACK FOOTER //
// src/components/index2/index10.vue